module.exports = __webpack_public_path__ + "static/media/poolParty.77a00d35.gif";